import { AlertCircle } from "lucide-react";
import { Button } from "components/common";

interface ProjectsLoadErrorStateProps {
  onRetry: () => void;
}

/** The project list failed to load, so the workspace may not be empty. */
export const ProjectsLoadErrorState = ({ onRetry }: ProjectsLoadErrorStateProps) => (
  <div
    role="alert"
    className="flex flex-col items-center gap-3 rounded-xl border border-border px-4 py-12 text-center"
  >
    <AlertCircle className="h-6 w-6 text-danger" aria-hidden />
    <p className="text-sm text-foreground">Couldn't load projects</p>
    <p className="text-sm text-muted-foreground">Check your connection, then try again.</p>
    <Button type="button" variant="badge" color="gray" size="sm" onClick={onRetry}>
      Try again
    </Button>
  </div>
);
